export default __webpack_public_path__ + "static/media/hero_ph.b2a5c29f.jpg";